import { render } from "./CardTable.vue?vue&type=template&id=528d0a79&ts=true"
import script from "./CardTable.vue?vue&type=script&lang=ts"
export * from "./CardTable.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__